import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.252 25.348a.932.932 0 0 0 .807 1.407H27.94a.932.932 0 0 0 .808-1.407L18.54 7.849a1.2 1.2 0 0 0-2.08 0zm-1.402-.823 10.207-17.5a2.83 2.83 0 0 1 4.886 0l10.207 17.5a2.558 2.558 0 0 1-2.21 3.849H7.06a2.558 2.558 0 0 1-2.21-3.849m12.65-12.4a.815.815 0 0 1 .812.813v6.5a.813.813 0 1 1-1.625 0v-6.5a.815.815 0 0 1 .813-.813M16.281 23.5a1.219 1.219 0 1 1 1.219 1.219 1.22 1.22 0 0 1-1.219-1.219"
    }, null, -1)
  ])))
}
export default { render: render }